import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { parseApiAsset } from '@morpho-org/dapp-core';
import { isDefined } from '@morpho-org/morpho-ts';
import { formatters, getDigitsFromPriceAndAmount } from '@morpho-org/ui-v6/utils';
import { useMemo } from 'react';
import { useVaultV1ActionPanelData } from '@/components/VaultPage/VaultV1/VaultSimpleActionPanel/useVaultV1ActionPanelData';
import { useWeb3Context } from '@/contexts/Web3Context';
import { formatAdjustedAmount } from '@/helpers/formatters';
import { useVaultV1Apy, type VaultV1ApyInput } from '@/hooks/useVaultV1Apy';
export const useVaultV1RecapFormatting = t0 => {
  const $ = _c(48);
  const {
    vaultAddress,
    initialPosition,
    finalPosition
  } = t0;
  const {
    targetChainId
  } = useWeb3Context();
  let t1;
  if ($[0] !== targetChainId || $[1] !== vaultAddress) {
    t1 = {
      vaultAddress,
      chainId: targetChainId
    };
    $[0] = targetChainId;
    $[1] = vaultAddress;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    vaultData: vaultV1,
    isLoading: loading
  } = useVaultV1ActionPanelData(t1);
  vaultV1?.asset;
  const t2 = vaultV1?.asset;
  let t3;
  if ($[3] !== t2) {
    t3 = parseApiAsset(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const vaultAsset = t3;
  let t4;
  bb0: {
    if (!vaultV1 || !targetChainId) {
      t4 = undefined;
      break bb0;
    }
    let t5;
    if ($[5] !== vaultV1.address || $[6] !== vaultV1.asset || $[7] !== vaultV1.rewards || $[8] !== vaultV1.state) {
      t5 = {
        address: vaultV1.address,
        asset: vaultV1.asset,
        state: vaultV1.state,
        rewards: vaultV1.rewards
      };
      $[5] = vaultV1.address;
      $[6] = vaultV1.asset;
      $[7] = vaultV1.rewards;
      $[8] = vaultV1.state;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = t5;
  }
  const apyInput = t4;
  let t5;
  if ($[10] !== apyInput) {
    t5 = {
      vaultV1: apyInput
    };
    $[10] = apyInput;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    apy,
    netApy,
    performanceFee,
    points,
    rewards
  } = useVaultV1Apy(t5);
  let t6;
  if ($[12] !== netApy) {
    t6 = formatters.percent.digits(2).default("-").unit("%").max(10).of(netApy, 18);
    $[12] = netApy;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const formattedNetApy = t6;
  let t7;
  bb1: {
    if (!isDefined(vaultAsset)) {
      t7 = "-";
      break bb1;
    }
    let t8;
    if ($[14] !== initialPosition || $[15] !== vaultAsset.decimals || $[16] !== vaultAsset.price) {
      t8 = formatters.commas.digits(getDigitsFromPriceAndAmount(vaultAsset.price, initialPosition)).trailingZero(!initialPosition).of(initialPosition, vaultAsset.decimals);
      $[14] = initialPosition;
      $[15] = vaultAsset.decimals;
      $[16] = vaultAsset.price;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t7 = t8;
  }
  const formattedInitialPosition = t7;
  let t8;
  bb2: {
    if (!isDefined(vaultAsset)) {
      t8 = "-";
      break bb2;
    }
    let t9;
    if ($[18] !== finalPosition || $[19] !== vaultAsset.decimals || $[20] !== vaultAsset.price) {
      t9 = formatters.commas.digits(getDigitsFromPriceAndAmount(vaultAsset.price, finalPosition)).trailingZero(!finalPosition).of(finalPosition, vaultAsset.decimals);
      $[18] = finalPosition;
      $[19] = vaultAsset.decimals;
      $[20] = vaultAsset.price;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = t9;
  }
  const formattedFinalPosition = t8;
  let t9;
  bb3: {
    if (!initialPosition || !isDefined(vaultAsset)) {
      t9 = undefined;
      break bb3;
    }
    const t10 = !initialPosition;
    let t11;
    if ($[22] !== initialPosition || $[23] !== t10 || $[24] !== vaultAsset.decimals || $[25] !== vaultAsset.price || $[26] !== vaultAsset.symbol) {
      t11 = formatAdjustedAmount({
        price: vaultAsset.price,
        amount: initialPosition,
        decimals: vaultAsset.decimals,
        withTrailingZero: t10,
        symbol: vaultAsset.symbol
      });
      $[22] = initialPosition;
      $[23] = t10;
      $[24] = vaultAsset.decimals;
      $[25] = vaultAsset.price;
      $[26] = vaultAsset.symbol;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    t9 = t11;
  }
  const detailedFormattedInitialPosition = t9;
  let t10;
  bb4: {
    if (!finalPosition || !isDefined(vaultAsset)) {
      t10 = undefined;
      break bb4;
    }
    const t11 = !finalPosition;
    let t12;
    if ($[28] !== finalPosition || $[29] !== t11 || $[30] !== vaultAsset.decimals || $[31] !== vaultAsset.price || $[32] !== vaultAsset.symbol) {
      t12 = formatAdjustedAmount({
        price: vaultAsset.price,
        amount: finalPosition,
        decimals: vaultAsset.decimals,
        withTrailingZero: t11,
        symbol: vaultAsset.symbol
      });
      $[28] = finalPosition;
      $[29] = t11;
      $[30] = vaultAsset.decimals;
      $[31] = vaultAsset.price;
      $[32] = vaultAsset.symbol;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    t10 = t12;
  }
  const detailedFormattedFinalPosition = t10;
  let t11;
  if ($[34] !== apy || $[35] !== detailedFormattedFinalPosition || $[36] !== detailedFormattedInitialPosition || $[37] !== formattedFinalPosition || $[38] !== formattedInitialPosition || $[39] !== formattedNetApy || $[40] !== loading || $[41] !== netApy || $[42] !== performanceFee || $[43] !== points || $[44] !== rewards || $[45] !== vaultAsset || $[46] !== vaultV1) {
    t11 = {
      vaultV1,
      vaultAsset,
      apy,
      performanceFee,
      netApy,
      points,
      rewards,
      formattedNetApy,
      formattedInitialPosition,
      detailedFormattedInitialPosition,
      formattedFinalPosition,
      detailedFormattedFinalPosition,
      loading
    };
    $[34] = apy;
    $[35] = detailedFormattedFinalPosition;
    $[36] = detailedFormattedInitialPosition;
    $[37] = formattedFinalPosition;
    $[38] = formattedInitialPosition;
    $[39] = formattedNetApy;
    $[40] = loading;
    $[41] = netApy;
    $[42] = performanceFee;
    $[43] = points;
    $[44] = rewards;
    $[45] = vaultAsset;
    $[46] = vaultV1;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  return t11;
};